const useSelectedFinYear = () => {
  const finyear = sessionStorage.getItem("finYear");
  let startFinYear = finyear?.split("-")[0];
  let currentFinYear = String(new Date().getFullYear());
  let startFinDate = `${finyear?.split("-")[0]}-04-01`;
  let endFinDate = `20${finyear?.split("-")[1]}-03-31`;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, "0"); 
  const currentDay = currentDate.getDate().toString().padStart(2, "0");
  const currentDateStr = `${currentYear}-${currentMonth}-${currentDay}`;

  const filterOnSelectedFinYear = (data, date) => {
    return data?.filter((item) => {
      if (startFinYear === currentFinYear) {
        return (item[date]) >= (startFinDate) && (currentDateStr) === (currentDateStr);
      } else {
        return (item[date]) >= (startFinDate) && (item[date]) <= (endFinDate);
      }
    });
  };

  return {
    finyear,
    startFinDate,
    endFinDate,
    startFinYear,
    currentFinYear,
    currentYear,
    currentDateStr,
    filterOnSelectedFinYear,
  };
};

export default useSelectedFinYear;
